module.exports = __webpack_public_path__ + "img/kefu.a9fdc6b6.png";